
import { Vehicle } from '@clients/myTrips';
import { Fitment } from '@clients/vcfg';
import BasicSetupScreen from '@components/vehicle-setup/BasicSetupScreen.vue';
import { LoadState } from '@util/types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const TriplogModule = namespace('Triplog');

@Component({
  name: 'SetupStep5',
  components: {
    BasicSetupScreen,
  }
})
export default class SetupStep5 extends Vue {
  @Prop({ required: true })
  private vehicle: Vehicle;

  @Prop({ default: false })
  private standaloneScreen: boolean;

  @TriplogModule.Action('fetchFitment')
  private fetchFitment;

  @TriplogModule.Getter('getFitment')
  private fitment: Fitment;

  @TriplogModule.Getter('getFitmentStatus')
  private fitmentStatus: LoadState;

  created() {
    if (this.vehicle && !this.standaloneScreen) {
      this.fetchFitment({ vehicle: this.vehicle })
        .catch(() => this.fetchFitment({ vehicle: this.vehicle }));
    }
  }

  get confirmationText() {
    return this.standaloneScreen ? undefined : 'Alle Schritte befolgt und durchgeführt';
  }

  get buttonText() {
    return this.standaloneScreen ? 'Fertig' : 'Fortfahren';
  }

  get socketImage() {
    return this.fitment.socket_wireframe_image;
  }

  get installSteps() {
    const device = this.fitment.devices.find(d => d.model === 'trakm8_connect300');
    if (device.installation_steps.length === 0) {
      return [{
        text: 'Stecken Sie den OBD-Stecker direkt in die OBD-Buchse.',
        image: device.installed_image
      }]
    } else {
      return device.installation_steps;
    }
  }

  get fitmentError() {
    return this.fitmentStatus !== LoadState.Loading && this.fitmentStatus !== LoadState.Success;
  }
}
